(function () {
  // Standard published men's shoe size conversion table (EU is the source of truth,
  // since that's what's stored in Zunuci's variant data). Approximate by design —
  // actual fit can vary by style/supplier. Covers the full EU 35-50 range used across
  // the catalog (including half sizes for styles like Terra), not just 36-46.
  var EU_TO_UK_US = {
    35: { uk: '2.5', us: '3.5' },
    36: { uk: '3.5', us: '4' },
    37: { uk: '4', us: '4.5' },
    38: { uk: '5', us: '5.5' },
    39: { uk: '6', us: '6.5' },
    39.5: { uk: '6.5', us: '7' },
    40: { uk: '6.5', us: '7' },
    40.5: { uk: '7', us: '7.5' },
    41: { uk: '7.5', us: '8' },
    42: { uk: '8', us: '8.5' },
    42.5: { uk: '8.5', us: '9' },
    43: { uk: '9', us: '9.5' },
    44: { uk: '9.5', us: '10' },
    45: { uk: '10.5', us: '11' },
    46: { uk: '11', us: '11.5' },
    47: { uk: '12', us: '13' },
    48: { uk: '13', us: '14' },
    49: { uk: '13.5', us: '14.5' },
    50: { uk: '14', us: '15' }
  };

  function findSizeFieldsets() {
    var fieldsets = document.querySelectorAll('fieldset.product-form__input--pill');
    var matches = [];
    fieldsets.forEach(function (fieldset) {
      var legend = fieldset.querySelector('legend');
      if (legend && /size/i.test(legend.textContent)) {
        matches.push(fieldset);
      }
    });
    return matches;
  }

  function buildNote() {
    var wrapper = document.createElement('div');
    wrapper.className = 'size-unit-toggle';

    var note = document.createElement('p');
    note.className = 'size-unit-toggle__note';
    note.textContent = 'Runs slightly small. If you\'re between sizes, go a size up.';
    wrapper.appendChild(note);

    return wrapper;
  }

  function applyUnit(fieldset, unit) {
    var labels = fieldset.querySelectorAll('label[for]');
    labels.forEach(function (label) {
      // Always read the EU size from the input's value attribute — the authoritative
      // source that Dawn never rewrites — rather than the label's visible text, which
      // Dawn does refresh (e.g. to update availability styling) whenever the selected
      // variant changes. Reading from cached/observed text goes stale after that refresh.
      var input = document.getElementById(label.getAttribute('for'));
      if (!input) return;

      // parseFloat (not parseInt) so half sizes like "39.5" resolve to their own
      // conversion-table entry instead of being truncated down to "39".
      var euSize = parseFloat(input.value);
      if (isNaN(euSize)) return;

      var conversion = EU_TO_UK_US[euSize];
      var displayValue = String(euSize);
      if (unit === 'UK' && conversion) {
        displayValue = conversion.uk;
      } else if (unit === 'US' && conversion) {
        displayValue = conversion.us;
      }

      // Only replace the leading text node so any nested markup (e.g. the hidden
      // "unavailable" span) stays intact.
      var firstTextNode = null;
      for (var i = 0; i < label.childNodes.length; i++) {
        if (label.childNodes[i].nodeType === Node.TEXT_NODE) {
          firstTextNode = label.childNodes[i];
          break;
        }
      }
      if (firstTextNode) {
        firstTextNode.textContent = displayValue;
      } else {
        label.insertBefore(document.createTextNode(displayValue), label.firstChild);
      }
    });
  }

  // Visual-only ascending sort. Unlike the old approach (removed 2026-09-15 after it
  // broke pill box styling and click handling), this NEVER moves, clones, or reparents
  // any input/label element — DOM order and the input+label CSS sibling adjacency stay
  // exactly as Dawn originally rendered them. Only visible position changes, via the
  // flexbox `order` property, applied to the label only (the radio input is already
  // position:absolute/clipped in the base pill CSS, so it never participates in layout
  // anyway — no need to touch it). The fieldset only becomes a flex container when it
  // carries the size-unit-toggle-active class (added below, scoped in
  // size-unit-toggle.css), so no other pill picker on the site is affected.
  function applyVisualOrder(fieldset) {
    var pairs = [];
    fieldset.querySelectorAll('label[for]').forEach(function (label) {
      var input = document.getElementById(label.getAttribute('for'));
      if (!input) return;
      var numericValue = parseFloat(label.textContent.trim());
      if (isNaN(numericValue)) return;
      pairs.push({ label: label, value: numericValue });
    });

    pairs.sort(function (a, b) {
      return a.value - b.value;
    });

    pairs.forEach(function (pair, index) {
      pair.label.style.order = index;
    });
  }

  function updateLegendText(fieldset, unit) {
    var legend = fieldset.querySelector('legend');
    if (!legend) return;

    var unitLabel = unit === 'UK' ? 'UK Size' : unit === 'US' ? 'US Size' : 'EU Size';

    // Only replace the direct text node so we don't disturb anything else in the legend.
    var firstTextNode = null;
    for (var i = 0; i < legend.childNodes.length; i++) {
      if (legend.childNodes[i].nodeType === Node.TEXT_NODE) {
        firstTextNode = legend.childNodes[i];
        break;
      }
    }
    if (firstTextNode) {
      firstTextNode.textContent = unitLabel;
    } else {
      legend.textContent = unitLabel;
    }
  }

  function initFieldset(fieldset) {
    var detectedUnit = window.zunuciDefaultSizeUnit || 'EU';

    if (!fieldset.dataset.unitToggleInit) {
      fieldset.dataset.unitToggleInit = 'true';
      fieldset.classList.add('size-unit-toggle-active');
      var note = buildNote();
      var legend = fieldset.querySelector('legend');
      legend.insertAdjacentElement('afterend', note);
    }

    updateLegendText(fieldset, detectedUnit);

    // Always reapply, even on repeat calls — Dawn re-renders label text on every
    // variant change, so the conversion has to be reasserted every time too.
    applyUnit(fieldset, detectedUnit);
    applyVisualOrder(fieldset);
  }

  function init() {
    findSizeFieldsets().forEach(function (fieldset) {
      initFieldset(fieldset);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Dawn's product-info component fetches a fresh copy of the variant picker over the
  // network on every size/color change and swaps it into the page wholesale (see
  // ProductInfo.handleUpdateProductInfo -> updateOptionValues in product-info.js). That
  // swap is asynchronous, so a fixed setTimeout after the 'change' event fires too early
  // and the freshly-swapped-in labels show raw EU numbers again. Dawn publishes its own
  // "finished updating" signal for exactly this — subscribe to that instead of guessing
  // at network timing.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      // Dawn's publish() calls every subscriber in a plain loop with no error isolation
      // between them — an uncaught error here could stop any other app/script subscribed
      // to the same event (e.g. a color-swatch app) from ever running. Never let this
      // callback throw.
      try {
        init();
      } catch (error) {
        console.error('size-unit-toggle:', error);
      }
    });
  } else {
    // Defensive fallback if Dawn's pub/sub globals aren't available for some reason.
    document.addEventListener('change', function (event) {
      if (event.target.closest('variant-selects')) {
        setTimeout(init, 300);
      }
    });
  }
})();
